// extracted by mini-css-extract-plugin
module.exports = {"header":"Index_header__1oLj9"};